export default function applyMap (map, baseItem, store) {
  return Object.keys(map).reduce((item, fieldName) => {
    return {
      ...item,
      [fieldName]: map[fieldName].call(baseItem, store, map)
    }
  }, baseItem)
}
